/* External */
import mergeL from "lodash/merge";
import setL from "lodash/set";
import cloneDeepL from "lodash/cloneDeep";

/* Actions */
import { ACTION_TYPES } from "./actions.js";

/* Others */
import { STATUS_TYPES } from "../../utils";

const initialState = {
  login: {
    status: STATUS_TYPES.UNLOAD_STATE,
    error: {}
  },
  sessionToken: "",
  deviceId: "",
  account: {},
  entitled: null,
  isLoggingOut: false
};

export default function user(state = initialState, { type, payload }) {
  let newLoginValue = {};
  switch (type) {
    case ACTION_TYPES.REQUEST:
      newLoginValue = { ...state.login, status: STATUS_TYPES.INIT_STATE };
      return { ...state, login: newLoginValue };
    case ACTION_TYPES.SUCCESS:
      newLoginValue = { ...state.login, status: STATUS_TYPES.SUCCEED_STATE };
      return { ...state, login: newLoginValue };
    case ACTION_TYPES.FAILURE:
      newLoginValue = {
        ...state.login,
        status: STATUS_TYPES.FAILED_STATE,
        error: payload
      };
      return { ...state, login: newLoginValue };
    case ACTION_TYPES.SET_USER: {
      const newState = cloneDeepL(state);
      return mergeL(newState, payload);
    }
    case ACTION_TYPES.UPDATE_USER: {
      setL(state, payload.property, payload.value);
      return { ...state };
    }
    case ACTION_TYPES.RESET:
      return initialState;
    case ACTION_TYPES.LOGOUT:
      return { ...state, isLoggingOut: true };
    default:
      return state;
  }
}
